import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ErrorContext } from "../../../utils/context/error";
import IconM from "../../dashboard/menu/icons/Icon";
import { getArchivosImgAll, getMessageImgxArea, setBloqueaArchivo } from "../../../services/archivos";
import ImageModal from "./imagemodal";
import useTable from "../../../hooks/table";
import TableFooter from "../../../hooks/table/footer";

function UploadVideoView() 
{
  const [Area, setArea] = useState([]);
  const [archivos, setArchivos] = useState([]);

  const { setShowToast, setOpciones } = ErrorContext();
  const [AreaId, setAreaId] = useState(0);
  const [AreaFId, setAreaFId] = useState(0);
  const [ArchivoId, setArchivoId] = useState(0);
  const [showM, setShowM] = useState(false);
  const [tag, setTag] = useState(0);
  const [estado, setEstado] = useState("AC");
  const [selectedRow, setSelectedRow] = useState(null);
  const [page, setPage] = useState(1);
  const { slice, range } = useTable(archivos, page, 10);  
  
  
  const navigate = useNavigate();
  
  //-----------------------------------------------------
  const fillUploadImagen = async () => 
    {
      setShowToast(false);
    
      const response = await getArchivosImgAll('VI');
      if (response) 
        {
          if (response.status === 200) 
            {
              setArchivos(response.data.data);
              setArea(response.data.area);
            } 
          else 
          {
            const Mensaje = response.message;
            const opc = { type: "Danger", message: Mensaje, active: true };
            setOpciones(opc);
            setShowToast(true);
          }
       }
    };

  //------- boton crear-Editar-Eliminar Area
  const handleCrearArchivo = (tagId) => 
    {
      if (tagId === 0) 
        {
          setAreaId(AreaFId);
          setArchivoId(0);
        }
      setShowM(true);
      setTag(tagId);
    };
  
  //-------- Bloquea- Desbloquea
  const handleBloqueaArchivo = async (tagId) => 
    {
       setShowToast(false);
       const response = await setBloqueaArchivo(AreaId, ArchivoId, tagId);
       if (response) 
        {
           if (response.status === 200) 
            {
              const actualizado = response.data.data[0];
              setArchivos(prev =>
                          prev.map((item, idx) =>
                             idx === selectedRow
                           ? { ...item, Estado: actualizado.Estado, AreaId: actualizado.AreaId }
                           : item
                          )
                        );
              setTag(0);
              setEstado(response.data.data[0].Estado);
              setAreaId(response.data.data[0].AreaId);
            } 
           else 
           {
             const Mensaje = response.message;
             const opc = { type: "Danger", message: Mensaje, active: true };
             setOpciones(opc);
             setShowToast(true);
           }
        }
    };
  //-----------------------------------------------------
  const handlefilas = (Item, index) => 
    {
      setSelectedRow(index); 
      setAreaId(Item.AreaId);
      setArchivoId(Item.ArchivoId);
      setEstado(Item.Estado);
    };
  //-----------------------------------------------------
  const handleSubirArchivo = () =>
    {
      navigate('profile',
         {state:{Id:ArchivoId }}
      )
    }
  //-----------------------------------------------------
  const handleFiltrarInt =async(data) =>
    {
      const actualizado = data;
      if (tag ===0)
       {
         setArchivos(prev => 
          {
            const existe = prev.some(
               item => item.AreaId === actualizado.AreaId && item.ArchivoId === actualizado.ArchivoId
             );
             return existe ? prev : [...prev, actualizado];
          });
       }
      
      if (tag ===1)
      {
        setArchivos(prev =>
             prev.map((item, idx) =>
                   idx === selectedRow
                ? { ...item, Estado: actualizado.Estado, AreaId: actualizado.AreaId, Descripcion: actualizado.Descripcion }
               : item
             )
          );
        setEstado(actualizado.Estado);
        setAreaId(actualizado.AreaId);
      }    
     
      if (tag ===2)
      {
        setArchivos(prev => prev.filter(item => item.AreaId === AreaId && item.ArchivoId !== ArchivoId));
        setSelectedRow(null);
      }  
     setTag(0);
         
  }
  //-----------------------------------------------------
  useEffect(() => {
    setShowM(false);
    fillUploadImagen();
  }, []);

    return (
      <>
        <div className="">
           <div className="paneltitle">
              <label className="text-[1.0rem] font-light text-gray-400 leading-none">Administración/Multimedia/Cargue Videos</label>
           </div>
        
           <div className="panelmenu">
              <button className="btnmenu" onClick={() => handleCrearArchivo(0)} >
                 <IconM svg="newfile" className="iconmenu" title="newfile" />
                 <span>Nuevo</span>
               </button>
       
               <button className="btnmenu" id="Editar" disabled={selectedRow === null} onClick={() => handleCrearArchivo(1)}>
                 <IconM svg="pencil" className="iconmenu" title="pencil" />
                 <span>Editar</span>
               </button>

               <button className="btnmenu" id="Eliminar" onClick={() => handleCrearArchivo(2)} disabled={selectedRow === null}>
                 <IconM svg="delfile" className="iconmenu" title="delfile" />
                 <span>Eliminar</span>
               </button>

               {estado === "AC" ? 
                (
                  <button className="btnmenu" id="Bloquear" disabled={selectedRow === null} onClick={() =>handleBloqueaArchivo(0)}>
                      <IconM svg="lock" className="iconmenu" title="lock" />
                      <span>Bloquear</span>
                  </button>
                ) : 
                (
                 <button className="btnmenu" id="Desbloquear" disabled={selectedRow === null} onClick={() =>handleBloqueaArchivo(1)}>
                   <IconM svg="dlock" className="iconmenu" title="dlock"/>
                   <span>Desbloquear</span>
                 </button>
               )}

              <button className="btnmenu" id="subir" disabled={selectedRow === null} onClick={() =>handleSubirArchivo()} >
                 <IconM svg="upload" className="iconmenu" title="upload" />
                 <span>Cargar</span>
              </button>
           </div>
           <div className="mt-2 rounded-lg border border-stone-200 overflow-x-auto">
               <table className="w-full table-auto">
                   <thead className="border-b border-stone-200 text-sm font-medium ">
                     <tr>
                        <th className="px-2.5 py-2 text-start font-medium">Id.</th>
                        <th className="px-2.5 py-2 text-start font-medium">Area</th>
                        <th className="px-2.5 py-2 text-start font-medium">Carpeta</th>
                        <th className="px-2.5 py-2 text-start font-medium">Videos</th>
                        <th className="px-2.5 py-2 text-start font-medium">Descripción</th>
                        <th className="px-2.5 py-2 text-start font-medium">Estado</th>
                     </tr>
                   </thead>
                   <tbody className="group text-sm text-stone-800 ">
                     {
                       slice.map((item, index) => 
                         {
                            return (
                               <tr className={`border-b border-stone-200 last:border-0 ${selectedRow === index ? 'bg-blue-50 selected cursor-pointer' : ''}`} key={index} id={`fila${item.ArchivoId}`} onClick={() => handlefilas(item, index)}>
                                  <td>
                                     <div className="flex w-full pl-1 gap-3 text-sm text-current">
                                       {item.ArchivoId}
                                     </div>
                                  </td>
                                  <td>{item.NombreArea}</td>
                                  <td>{item.Carpeta}</td>
                                  <td>{item.ItemId}</td>
                                  <td>{item.Descripcion}</td>
                                  <td className="center">
                                     {item.Estado === "AC" ? (<span className="tagac">Activo</span>) : (<span className="tagan">Suspendido</span>)}
                                  </td>
                               </tr>
                             )
                          }
                      )
                    }
                  </tbody>
               </table>
            </div>
        <TableFooter range={range} slice={slice} setPage={setPage} page={page} /> 
      </div>
      <ImageModal
        show={showM}
        AreaI={AreaId}
        AreaFId ={AreaFId}
        MensajeI={ArchivoId}
        Tag={tag}
        handleshow={setShowM}
        handleFiltrar={handleFiltrarInt}
       ></ImageModal>

        </>
      );
}
export default UploadVideoView;